module.exports = __webpack_public_path__ + "img/bottom3.55e14b0c.png";